import { createAsyncAction } from 'typesafe-actions';
import { IdType } from '@rootCommon/types/common';

export const resendEmailVerification = createAsyncAction(
  'RESEND_VERIFICATION_REQUEST',
  'RESEND_VERIFICATION_SUCCESS',
  'RESEND_VERIFICATION_FAILURE',
)<{ id: IdType; prefix: string; routeExtension?: string }, undefined, Error>();

export const resendEmailInvitation = createAsyncAction(
  'RESEND_INVITATION_REQUEST',
  'RESEND_INVITATION_SUCCESS',
  'RESEND_INVITATION_FAILURE',
)<{ id: IdType; prefix: string; routeExtension?: string }, undefined, Error>();
